import { styled, SxProps } from '@mui/material'
import { HallAvatar, UserAvatar } from '$common/avatar'
import { useServerStoryRibbonsWithSeparatedClientUserStory } from '$logic/story/react-hooks'
import { useClientUser } from '$logic/client-user'
import { AvatarSize } from '$common/avatar/avatar-base/types'
import { IS_STORY_ENABLED } from '$func/environmentInfo'
import { webliteOfficialChannelRoomId } from '$logic/hall/constant'

interface Props {
  size?: AvatarSize
  className?: string
  sx?: SxProps
  onClick: () => unknown
}

export const StoryToggler = ({
  size = AvatarSize._3XS,
  className,
  sx,
  onClick,
}: Props) => {
  const { nonClientRibbonStories: storyRibbons } =
    useServerStoryRibbonsWithSeparatedClientUserStory()
  const clientUser = useClientUser()
  const total = storyRibbons?.length > 3 ? 3 : storyRibbons?.length

  if (!IS_STORY_ENABLED) return null
  return (
    <Root
      className={className}
      sx={{ ...sx, cursor: 'pointer' }}
      onClick={onClick}
    >
      {storyRibbons.length ? (
        <AvatarWrapper>
          {storyRibbons
            .slice(0, total)
            .reverse()
            .map(({ peerId, peerType }) => {
              return peerType === 'USER' ? (
                <StyledUserAvatar
                  withStory
                  className="story-avatar-group"
                  key={peerId}
                  userId={peerId}
                  size={size}
                  disableClick
                />
              ) : peerType === 'CHANNEL' || peerType === 'GROUP' ? (
                <StyledHallAvatar
                  key={peerId}
                  roomId={peerId}
                  withStory
                  size={size}
                  disableClick
                  className="story-avatar-group"
                />
              ) : null
            })}
        </AvatarWrapper>
      ) : (
        <StyledHallAvatar
          roomId={webliteOfficialChannelRoomId}
          size={size}
          disableClick
        />
      )}
    </Root>
  )
}

const AvatarWrapper = styled('div')`
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  .MuiBadge-root:not(:first-child) .avatar-base__root {
    margin-inline-end: -7px;
  }
`

const Root = styled('button')`
  height: 22px;
  width: fit-content;
  background: transparent;
  border: none;
  outline: none;
  direction: ltr;
  padding: unset;
`

const StyledUserAvatar = styled(UserAvatar)`
  &.story-avatar-group {
    outline: 3px solid ${({ theme }) => theme.palette.neutral000};
    border: none;
  }
`

const StyledHallAvatar = styled(HallAvatar)`
  &.story-avatar-group {
    outline: 3px solid ${({ theme }) => theme.palette.neutral000};
    border: none;
  }
`
